import { Component, AfterViewInit, OnDestroy, ElementRef, ViewChild, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-dashboard-testimonials',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard-testimonials.component.html',
  styleUrl: './dashboard-testimonials.component.scss'
})
export class DashboardTestimonialsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('testimonialContainer') testimonialContainer!: ElementRef;
  
  constructor(private sanitizer: DomSanitizer) {}
  
  ngOnInit() {
    console.log("DashboardTestimonialsComponent initialized!");
  }
  
  getSafeUrl(url: string | undefined): SafeResourceUrl | null {
    if (!url) return null;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  testimonials = [
    {
      videoUrl: "https://drive.google.com/file/d/1WwZHex30ng3I0jXwRYkVC5jnW2W6w5zh/preview",
      name: "Parishi",
      subtext: "Management, University of London",
      avatarColor: "#CDD12A",
      avatarText: "P",
      avatarTextColor: "#000086",
      bgColor: "#000086", // specific for video card footer
      borderColor: "#000086",
      badgeText: "5 ★",
      badgeBgColor: "#000086",
      badgeTextColor: "white"
    },
    {
      text: "Fit's been an overwhelming few days, with the move etc. Secondly, and more importantly, thank you so very much for your email and the song. I truly appreciate the belief you've shown in my abilities throughout this process, and it is partly because of that that I could get whatever admits I got. You've made a world of a difference for me, and I'm so glad we got to work together. Thank you again",
      name: "Divisha",
      subtext: "ISB, Boston University",
      avatarColor: "#F7B801",
      avatarText: "D",
      avatarTextColor: "white",
      bgColor: "#FEF8E5",
      borderColor: "#FDEAB2",
      quoteColor: "#F7B801",
      badgeText: "5 ★",
      badgeBgColor: "#F7B801",
      badgeTextColor: "#000086"
    },
    {
      text: "I'm thrilled to share my admission to the Master of Engineering program at Cornell University for Fall 2026. A huge thank you to the Grad Pilots team for their invaluable support in helping me join Cornell's Engineering Management program in Ithaca. I couldn't have achieved this milestone without you!",
      name: "Aryan",
      subtext: "ME, Cornell University",
      avatarColor: "#CDD12A",
      avatarText: "A",
      avatarTextColor: "#000086",
      bgColor: "#FAFAE9",
      borderColor: "#E1E37F",
      quoteColor: "#CDD12A",
      badgeText: "Top Pick",
      badgeBgColor: "#CDD12A",
      badgeTextColor: "#000086"
    },
    {
      text: "A huge thank you to the Grad Pilots team for their incredible mentorship and for helping me showcase my background effectively. I truly appreciate your support in helping me reach this goal!",
      name: "Bismanjyot",
      subtext: "PHD, University of Michigan",
      avatarColor: "#F7B801",
      avatarText: "B",
      avatarTextColor: "white",
      bgColor: "#FEF8E5",
      borderColor: "#FDEAB2",
      quoteColor: "#F7B801",
      badgeText: "5 ★",
      badgeBgColor: "#F7B801",
      badgeTextColor: "#000086"
    },
    {
      videoUrl: "https://drive.google.com/file/d/1oDzogwYmII4G5UVpabpWo-DJAB9GoABX/preview",
      name: "Renee",
      subtext: "MS, University of Warwick",
      avatarColor: "#5250ED",
      avatarText: "R",
      avatarTextColor: "white",
      bgColor: "#F0EFFF", // Light purple/blue tint
      borderColor: "#E2E0FF",
      badgeText: "VERIFIED",
      badgeBgColor: "#000086",
      badgeTextColor: "white"
    },
    {
      text: "None of this would have been possible without all your hard work, constant motivation and belief in me. Thank you GradPilots - Operations for handling all the apps and helping me meet all deadlines! This win is as much yours as it is mine",
      name: "Manasvi",
      subtext: "CS Management, Columbia University",
      avatarColor: "#FF715B",
      avatarText: "M",
      avatarTextColor: "white",
      bgColor: "#FFF5F4",
      borderColor: "#FFE1DE",
      quoteColor: "#CDD12A", // Default yellow quote
      badgeText: "5 ★",
      badgeBgColor: "#F7B801",
      badgeTextColor: "#000086"
    },
    {
      text: "I am very thankful to you for the conversation and this test. For past few months I felt that none of the teacher understands a student by his abilities other than marks but today I am filled with gratitude because you deep dived in my personality and actually understood what I want. I promise you that I will try my best to practice the steps you guided me about. I am a bit shy in front of my parents that's why I didn't speak much today but I will surely approach you after my mid term examination and I will start working on myself.",
      name: "Mankeert",
      subtext: "MS Finance, Wayne State",
      avatarColor: "#F7B801",
      avatarText: "M",
      avatarTextColor: "white",
      bgColor: "#FEF8E5",
      borderColor: "#FDEAB2",
      quoteColor: "#F7B801",
      badgeText: "5 ★",
      badgeBgColor: "#F7B801",
      badgeTextColor: "#000086"
    },
    {
      videoUrl: "https://drive.google.com/file/d/19fDeF269gqS6IC4TNWBY3A-H7VceS5TO/preview",
      name: "Aryan",
      subtext: "ME, Cornell University",
      avatarColor: "#CDD12A",
      avatarText: "A",
      avatarTextColor: "#000086",
      bgColor: "#FAFAE9",
      borderColor: "#E1E37F",
      badgeText: "VERIFIED",
      badgeBgColor: "#CDD12A",
      badgeTextColor: "#000086"
    },
    {
      text: "Ma'am and sir are two of the best people to have by your side if you're thinking of applying to US or Canada. If you're hesitant or confused about your dream of studying abroad then stop overthinking,",
      name: "Sanat",
      subtext: "MS, British Columbia University",
      avatarColor: "#CDD12A",
      avatarText: "S",
      avatarTextColor: "#000086",
      bgColor: "#FAFAE9",
      borderColor: "#E1E37F",
      quoteColor: "#CDD12A",
      badgeText: "Top Pick",
      badgeBgColor: "#CDD12A",
      badgeTextColor: "#000086"
    }
  ];

  extendedTestimonials = [...this.testimonials, ...this.testimonials];
  
  private animationFrameId: number | null = null;
  private isPaused = false;

  ngAfterViewInit() {
    this.startAutoScroll();
  }

  ngOnDestroy() {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
  }

  pauseScroll() {
    this.isPaused = true;
  }

  resumeScroll() {
    this.isPaused = false;
  }

  startAutoScroll() {
    const scrollStep = () => {
      if (this.testimonialContainer && !this.isPaused) {
        const container = this.testimonialContainer.nativeElement;
        container.scrollLeft += 1;
        if (container.scrollLeft >= container.scrollWidth / 2) {
          container.scrollLeft = 0;
        }
      }
      this.animationFrameId = requestAnimationFrame(scrollStep);
    };
    this.animationFrameId = requestAnimationFrame(scrollStep);
  }
}
